import type { JSX } from 'react';
import { WikiDetailLayout, type WikiDetailLayoutProps } from './WikiDetailLayout';

export type WikiDetailVariant = 'standard' | 'narrow' | 'split';

export function resolveWikiDetailVariant(
  _variant: WikiDetailVariant | undefined,
): (props: WikiDetailLayoutProps) => JSX.Element | null {
  return WikiDetailLayout;
}
